import { useState } from "react";
import { Link } from "react-router";
import {
  Aviso,
  Cabecalho,
  Campo,
  Celula,
  CelulaCabecalho,
  Chip,
  Corpo,
  Linha,
  Tabela,
} from "../ui";
import { mensagemDoConsole } from "../../nucleo/console";
import {
  CLASSIFICACOES,
  ROTULO_DA_CLASSIFICACAO,
  caminhoDaOrganizacao,
  nomeDaOrganizacao,
  useOrganizacoesDoCadastro,
} from "../../nucleo/cadastro";

export function PainelDeOrganizacoes() {
  const [busca, setBusca] = useState("");
  const [classificacao, setClassificacao] = useState("");
  const organizacoes = useOrganizacoesDoCadastro({ busca, classificacao });

  return (
    <div data-testid="painel-de-organizacoes">
      <div className="grid gap-3 md:grid-cols-2 mb-3">
        <Campo
          rotulo="Buscar por nome ou CNPJ"
          value={busca}
          onChange={(evento) => setBusca(evento.target.value)}
          data-testid="busca-de-organizacoes"
        />
        <div className="campo">
          <label className="campo__rotulo" htmlFor="filtro-de-classificacao">
            Classificação
          </label>
          <select
            id="filtro-de-classificacao"
            className="campo__controle"
            value={classificacao}
            onChange={(evento) => setClassificacao(evento.target.value)}
          >
            <option value="">Todas</option>
            {CLASSIFICACOES.map((item) => (
              <option key={item} value={item}>
                {ROTULO_DA_CLASSIFICACAO[item]}
              </option>
            ))}
          </select>
        </div>
      </div>
      {organizacoes.isPending ? <p role="status">Carregando organizações…</p> : null}
      {organizacoes.isError ? <Aviso tom="erro">{mensagemDoConsole(organizacoes.error)}</Aviso> : null}
      {organizacoes.data && organizacoes.data.length === 0 ? (
        <Aviso tom="marca">Nenhuma organização encontrada.</Aviso>
      ) : null}
      {organizacoes.data && organizacoes.data.length > 0 ? (
        <Tabela legenda="Organizações cadastradas, com CNPJ, cidade e classificação.">
          <Cabecalho>
            <Linha>
              <CelulaCabecalho>Organização</CelulaCabecalho>
              <CelulaCabecalho>CNPJ</CelulaCabecalho>
              <CelulaCabecalho>Cidade</CelulaCabecalho>
              <CelulaCabecalho>Classificação</CelulaCabecalho>
            </Linha>
          </Cabecalho>
          <Corpo>
            {organizacoes.data.map((organizacao) => (
              <Linha key={organizacao.id} data-testid={`organizacao-${organizacao.id}`}>
                <Celula>
                  <Link to={caminhoDaOrganizacao(organizacao.id)}>
                    <b>{nomeDaOrganizacao(organizacao)}</b>
                  </Link>
                  {organizacao.nome_fantasia ? (
                    <div className="celula-secundaria">{organizacao.razao_social}</div>
                  ) : null}
                </Celula>
                <Celula>{organizacao.cnpj_formatado}</Celula>
                <Celula>
                  {[organizacao.cidade, organizacao.uf].filter(Boolean).join(" / ") || "—"}
                </Celula>
                <Celula>
                  {organizacao.classificacao ? (
                    <Chip estado={organizacao.classificacao === "estrategico" ? "ok" : "neutro"}>
                      {ROTULO_DA_CLASSIFICACAO[organizacao.classificacao]}
                    </Chip>
                  ) : (
                    "—"
                  )}
                </Celula>
              </Linha>
            ))}
          </Corpo>
        </Tabela>
      ) : null}
    </div>
  );
}
